function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 42,
    height: 42,
    rx: 5,
    transform: "rotate(180 42 42)",
    fill: "#3056D3",
    fillOpacity: 0.06,
    style: {
      fill: "#3056D3",
      fill: "color(display-p3 0.1882 0.3373 0.8275)",
      fillOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.907 25.675C28.7008 25.675 28.5289 25.6063 28.357 25.4688L21.0008 18.2156L13.6445 25.4344C13.3352 25.7438 12.8539 25.7438 12.5445 25.4344C12.2352 25.125 12.2352 24.6438 12.5445 24.3344L20.4508 16.5656C20.7602 16.2563 21.2414 16.2563 21.5508 16.5656L29.457 24.3344C29.7664 24.6438 29.7664 25.125 29.457 25.4344C29.3195 25.5719 29.1133 25.675 28.907 25.675Z",
    fill: "#3674CB",
    style: {
      fill: "#3674CB",
      fill: "color(display-p3 0.2118 0.4549 0.7961)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrow);
export default __webpack_public_path__ + "static/media/uparrow.be730ee5be02bcc5a613669f5b5ae3e6.svg";
export { ForwardRef as ReactComponent };